import { useState, useEffect, useMemo, useCallback } from "react"
import { getJson } from "../../../helpers/http"
import { API_ENDPOINTS } from "../../../helpers/api"
import { loadParkIds } from "../helpers/storage"

const useParkEntities = () => {
  const [entities, setEntities] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const parkIds = loadParkIds()
    if (parkIds.length === 0) return undefined
    let mounted = true
    setLoading(true)
    const url = `${API_ENDPOINTS.PARK_ENTITIES}?park_ids=${encodeURIComponent(parkIds.join(","))}&data_types=attractions,dining`
    getJson(url).then(({ data, error }) => {
      if (!mounted) return
      setLoading(false)
      if (!error && data?.entities) {
        setEntities(data.entities.filter((e) => e.location?.latitude && e.location?.longitude))
      }
    })
    return () => {
      mounted = false
    }
  }, [])

  const nameSet = useMemo(() => (entities ? new Set(entities.map((e) => e.name.toLowerCase())) : null), [entities])

  const filterByName = useCallback(
    (items) => (nameSet ? items.filter((i) => nameSet.has(i.name.toLowerCase())) : items),
    [nameSet]
  )

  return { entities, loading, filterByName }
}

export default useParkEntities
